<template>
  <div class="row max-height-vertical box-overflow">
    <div class="row scroll-outer">

      <div class="span-14-lg offset-1-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs">
        <p class="large" v-html="title"></p>
      </div>

      <div v-for="(paragraph, index) in content.paragraphs" v-bind:key="index" class="relative span-6-lg span-14-md offset-1-md span-14-sm offset-1-sm span-14-xs offset-1-xs bg-white share-flip-outer no-ratio-md" container-card="share-card" :class="lg_offset(index)" :style="ratio_styles">
        
        <div class="scroll-outer">
          <div class="share-flip-inner">
            
            <p>{{paragraph}}</p>

            <div class="share-button-container">
              <nav-button type="share">share</nav-button>
            </div>

          </div>
        </div>

      </div>

    </div>
  </div>
</template>

<style scoped lang="scss">
  .share-button-container {
    position: relative;
    display: flex;
    justify-content: flex-end;
  }
</style>

<script>
  import nav_button from '../../components/molecules/button'
  import {ratio_height, ratio_styles} from '../../utils/ratio_height'

  import 'nodelist-foreach-polyfill'; // ie11

  export default {
    props: ['title', 'content', 'active'],
    data () {
      return {
        ratio_styles
      }
    },
    methods: {
      lg_offset (ind) {
        if (ind > 0) {
          return 'offset-2-lg'
        }
        return 'offset-1-lg transform-up'
      },
      ratioInit () {
        ratio_height(this, '[container-card="share-card"]', 1/1.25)
        window.addEventListener('resize', () => {
          setTimeout(() => {
            ratio_height(this, '[container-card="share-card"]', 1/1.25)
          }, 500)   
        })
      },
      activeCallback () {
        if (this.active) {
          this.ratioInit()
        }
      }
    },
    components: {
      'nav-button': nav_button
    },
    watch: {
      active () {
        this.activeCallback()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// share_page.vue?57b0f5b4